<template>
  <v-page>
    <toolbar fixed>
      <template v-slot:left>
        <span class="v-toolbar__text">Privacy & Terms</span>
      </template>
    </toolbar>

    <list
      v-if="app.legal_privacy_policy_url || app.legal_terms_and_conditions_url"
      class="mt-1 mb-3"
      boxed
      :heading="`${appName} Privacy & Terms`"
    >
      <list-item
        v-if="app.legal_terms_and_conditions_url"
        chevron
        @click="() => goToUrl(app.legal_terms_and_conditions_url)"
      >
        <div class="v-list-item__title --centered ml-1">
          Terms & Conditions
        </div>
      </list-item>
      <list-item
        v-if="app.legal_privacy_policy_url"
        chevron
        @click="() => goToUrl(app.legal_privacy_policy_url)"
      >
        <div class="v-list-item__title --centered ml-1">
          Privacy Policy
        </div>
      </list-item>
    </list>

    <list class="mt-1" boxed heading="Platform Privacy & Terms">
      <list-item
        chevron
        @click="
          () =>
            goToUrl(
              'https://support.fitterapp.co/article/5-terms-conditions-of-use'
            )
        "
      >
        <div class="v-list-item__title --centered ml-1">
          Terms & Conditions
        </div>
      </list-item>
      <list-item
        chevron
        @click="
          () =>
            goToUrl('https://support.fitterapp.co/article/19-privacy-policy')
        "
      >
        <div class="v-list-item__title --centered ml-1">
          Privacy Policy
        </div>
      </list-item>
      <list-item
        chevron
        @click="
          () => goToUrl('https://support.fitterapp.co/article/37-cookie-policy')
        "
      >
        <div class="v-list-item__title --centered ml-1">
          Cookie Policy
        </div>
      </list-item>
    </list>
  </v-page>
</template>

<script>
import { mapGetters } from "vuex"

import Toolbar from "@/components/Toolbar"
import List from "@/components/List"
import ListItem from "@/components/ListItem"

export default {
  components: {
    Toolbar,
    List,
    ListItem
  },

  methods: {
    goToUrl(url) {
      window.open(url, "_blank")
    }
  },

  computed: {
    ...mapGetters(["appName", "app"])
  }
}
</script>
